import { EVENTS } from "../../../js/constants";

class MultiSelect {
  /**
   * @param {HTMLElement} element - multiselect element
   */
  constructor(element) {
    this.element = element;

    this.summary = this.element.querySelector(".js-MultiSelect-summary");
    this.dropdown = this.element.querySelector(".js-MultiSelect-dropdown");
    this.inputs = [...this.dropdown.querySelectorAll("input")];
    this.resetButton = this.element.querySelector(
      ".js-Multiselect-resetButton"
    );

    this._resetSelection = this._resetSelection.bind(this);
    this._updateSummary = this._updateSummary.bind(this);

    this._init();
  }

  /**
   * init
   */
  _init() {
    this._initOptions();
    this._bindEvents();
  }

  /**
   * init options with progressive enhancement
   */
  _initOptions() {
    this.element.classList.add("is-initialized");
    this._updateSummary();
    this._toggleInputsTabindex({ tabbable: false });
    if ([...this.dropdown.querySelectorAll("input:checked")].length) {
      this.resetButton.classList.remove("u-hiddenVisually");
    }
  }

  /**
   * bind events
   */
  _bindEvents() {
    this.summary.addEventListener("click", (e) => {
      e.stopPropagation();
      const isHidden = this.summary.getAttribute("aria-expanded") === "false";
      this._toggleDropdown({ hidden: !isHidden });
    });
    window.addEventListener("click", (e) => {
      const clickOutsideOfEl = !this.element.contains(e.target);
      this._toggleDropdown({ hidden: clickOutsideOfEl });
    });
    this.inputs.forEach((input) => {
      input.addEventListener("change", this._updateSummary);
    });
    this.resetButton.addEventListener("click", this._resetSelection);
  }

  /**
   * toggle dropdown visibility
   *
   * @param {object} config - config
   * @param {boolean} config.hidden
   */
  _toggleDropdown({ hidden }) {
    this._toggleInputsTabindex({ tabbable: !hidden });
    this.dropdown.classList.toggle("u-hiddenVisually", hidden);
    this.summary.setAttribute("aria-expanded", String(!hidden));
  }

  /**
   * toggle input tabindex
   * inputs shouldn't be tabbable if the dropdown is hidden
   *
   * @param {object} config - config
   * @param {boolean} config.tabbable
   */
  _toggleInputsTabindex({ tabbable }) {
    const tabindex = tabbable ? "0" : "-1";

    this.inputs.forEach((input) => {
      input.setAttribute("tabindex", tabindex);
    });
  }

  /**
   * handles click of the resetButton
   */
  _resetSelection() {
    this.inputs.forEach((option) => {
      // eslint-disable-next-line no-param-reassign
      option.checked = false;
    });
    this._updateSummary();
    this.element.dispatchEvent(
      new CustomEvent(EVENTS.MULTISELECT_RESET, { bubbles: true })
    );
  }

  /**
   * update summary and output truncated selected options
   */
  _updateSummary() {
    const checkedOptions = [
      ...this.dropdown.querySelectorAll("input:checked + label"),
    ];

    if (checkedOptions.length) {
      let summaryLabel = "";
      checkedOptions.forEach((option, i) => {
        summaryLabel = i
          ? `${summaryLabel}, ${option.innerHTML}`
          : option.innerHTML;
      });
      this.summary.innerHTML = summaryLabel;
    } else {
      this.summary.innerHTML = "";
    }
  }
}

export default MultiSelect;
